import { c as _c } from "react/compiler-runtime";
import * as React from 'react';
import { escapeRegExp } from 'lodash';
import { WithChildrenCommonProps } from '@types';
export type HighlightProps = WithChildrenCommonProps<{
  /** Part of text to be highlighted */
  query?: string;
  /**
   * Function that will return an array of strings.
   * Those that match with the query are the ones highlighted.
   * By default matches start of word
   */
  searchFn?: (text: string, query?: string) => string[];
  /** String to highlight */
  children?: string;
}>;
export function defaultHighlightFn(text: string, query?: string): string[] {
  if (!query?.trim()) {
    return [text];
  }
  return text.split(new RegExp(`(\\s|^)(${escapeRegExp(query.trim())})`, 'gi'));
}
const HighlightComp = t0 => {
  const $ = _c(16);
  let children;
  let query;
  let rest;
  let t1;
  if ($[0] !== t0) {
    ({
      query,
      searchFn: t1,
      children,
      ...rest
    } = t0);
    $[0] = t0;
    $[1] = children;
    $[2] = query;
    $[3] = rest;
    $[4] = t1;
  } else {
    children = $[1];
    query = $[2];
    rest = $[3];
    t1 = $[4];
  }
  const searchFn = t1 === undefined ? defaultHighlightFn : t1;
  const isNotString = typeof children !== "string";
  if (!children || isNotString) {
    isNotString && console.warn("\xABHighlight\xBB children must be an string");
    return null;
  }
  let t2;
  let t3;
  if ($[5] !== children || $[6] !== query || $[7] !== rest || $[8] !== searchFn) {
    const splittedText = searchFn(children, query);
    t2 = rest;
    let t4;
    if ($[11] !== query) {
      t4 = (text, index) => {
        const isMatch = text.toLocaleLowerCase().trim() === query?.toLocaleLowerCase().trim();
        return isMatch ? <span className="underline text-gray-dark font-semibold" key={index}>{text}</span> : text;
      };
      $[11] = query;
      $[12] = t4;
    } else {
      t4 = $[12];
    }
    t3 = splittedText.map(t4);
    $[5] = children;
    $[6] = query;
    $[7] = rest;
    $[8] = searchFn;
    $[9] = t2;
    $[10] = t3;
  } else {
    t2 = $[9];
    t3 = $[10];
  }
  let t4;
  if ($[13] !== t2 || $[14] !== t3) {
    t4 = <span {...t2}>{t3}</span>;
    $[13] = t2;
    $[14] = t3;
    $[15] = t4;
  } else {
    t4 = $[15];
  }
  return t4;
};
const Highlight = React.memo(HighlightComp);
export { Highlight };